import React from "react";
import { useMediaQuery } from "@mui/material";

const Footer = () => {
	const isMobile = useMediaQuery("(max-width:1100px)"); // Adjusted media query for better transition

	return (
		<footer
			className={`dark:text-gray-300 py-4 px-3 w-full flex flex-col items-center bottom-0 left-0 ${
				isMobile ? "ml-0" : "ml-36"
			}`}
		>
			{/* Quick Links - One Line, Centered */}
			<div className="w-full flex justify-center">
				<ul className="flex flex-wrap gap-4 text-xs sm:text-sm">
					<li><a href="/about" className="hover:text-gray-400">About Us</a></li>
					<li><a href="/contact" className="hover:text-gray-400">Contact Us</a></li>
					<li><a href="/privacy" className="hover:text-gray-400">Privacy Policy</a></li>
					<li><a href="/donation" className="hover:text-gray-400">Donate to Support</a></li>
				</ul>
			</div>

			{/* Copyright Notice - Separate Line */}
			<div className="w-full text-center mt-2 pt-2 text-xs sm:text-sm">
				&copy; {new Date().getFullYear()} MaterialLogs.com. All rights reserved.
			</div>
		</footer>
	);
};

export default Footer;
